// Session management utility

const SESSION_KEY_STORAGE = 'billing_session_key'

// Get the current session key from localStorage
export const getSessionKey = (): string | null => {
  return localStorage.getItem(SESSION_KEY_STORAGE)
}

// Set the session key in localStorage
export const setSessionKey = (key: string): void => {
  localStorage.setItem(SESSION_KEY_STORAGE, key)
}

// Clear the session key (logout)
export const clearSessionKey = (): void => {
  localStorage.removeItem(SESSION_KEY_STORAGE)
}

// Check if user is authenticated
export const isAuthenticated = (): boolean => {
  const key = getSessionKey()
  return key !== null && key.length > 0
}
